/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ICoordenadas } from 'modelos/src';
import { Observable } from 'rxjs';

/** Resultado de búsqueda de Nominatim con polygon_geojson=1. */
export interface IOsmResult {
  place_id: number;
  display_name: string;
  lat: string;
  lon: string;
  type: string;
  addresstype?: string;
  geojson?: {
    type: string;
    coordinates: any;
  };
}

/**
 * Búsqueda de límites administrativos en OpenStreetMap (Nominatim).
 * Reemplaza el proceso manual: OSM → relation ID → polygons.openstreetmap.fr
 * → adaptar GeoJSON → importador. Acá: buscás por nombre y listo.
 *
 * Usa HttpClient crudo (NO HttpService): nada de auth/refresh contra Nominatim.
 * Uso esporádico (alta de clientes) → dentro de la política de Nominatim.
 */
@Injectable({ providedIn: 'root' })
export class OsmService {
  private http = inject(HttpClient);

  public buscar(texto: string): Observable<IOsmResult[]> {
    const params = new HttpParams()
      .set('q', texto)
      .set('format', 'jsonv2')
      .set('polygon_geojson', '1')
      .set('limit', '5')
      .set('accept-language', 'es');
    return this.http.get<IOsmResult[]>(
      'https://nominatim.openstreetmap.org/search',
      { params },
    );
  }

  /**
   * GeoJSON ([lng, lat]) → coordenadas Google ({lat, lng}).
   * Polygon y MultiPolygon; solo anillos exteriores (sin agujeros,
   * igual que el resto del sistema).
   */
  public toCoordenadas(geojson?: {
    type: string;
    coordinates: any;
  }): ICoordenadas[][] {
    if (!geojson) {
      return [];
    }
    const anillo = (puntos: [number, number][]): ICoordenadas[] =>
      (puntos || []).map(([lng, lat]) => ({ lat, lng }));

    if (geojson.type === 'Polygon') {
      return [anillo(geojson.coordinates?.[0])];
    }
    if (geojson.type === 'MultiPolygon') {
      return (geojson.coordinates || []).map((poly: any) => anillo(poly?.[0]));
    }
    // Puntos o líneas (resultados que no son límites administrativos)
    return [];
  }
}
